// extracted by mini-css-extract-plugin
module.exports = {"ReviewCardsContainer":"Reviews_ReviewCardsContainer___7KQd"};